module.exports = __webpack_public_path__ + "src/app/_content/MINIFonts/mini_sans_serif-regular-web.woff?ab6f017c061099937c051d8876d56404";